import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Stack, Skeleton, Divider } from '@mui/material'
import type { FC } from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import type { To } from 'react-router'

import { remUnit, unit, ICONS, COLORS, DividerWithLabel } from '@hcr/ui'

import { LayoutNavigationBack, Metadata } from '../../common'

interface AccountLoadingProps {
  to: To
}

export const AccountLoading: FC<AccountLoadingProps> = ({ to }) => {
  const { t } = useTranslation()

  return (
    <LayoutNavigationBack to={to} arrowVariant='text'>
      <Metadata title={t('page-title.account')} />
      <Stack sx={{ paddingY: unit(24) }}>
        <Box
          bgcolor={COLORS.vaalea['60%']}
          display='flex'
          justifyContent='space-between'
          paddingTop={unit(3.5)}
          paddingBottom={unit(4.5)}
          paddingX={unit(7)}
        >
          <Stack gap={unit(0.5)}>
            <Skeleton width={unit(65)} height={unit(5.5)} variant='rectangular' />
            <Skeleton width={unit(35)} height={unit(4.5)} />
          </Stack>
        </Box>

        <Divider />

        <Box
          bgcolor={COLORS.vaalea['60%']}
          display='flex'
          justifyContent='space-between'
          paddingTop={unit(3.5)}
          paddingBottom={unit(4.5)}
          paddingX={unit(7)}
        >
          <Stack gap={unit(0.5)}>
            <Skeleton width={unit(65)} height={unit(7)} variant='rectangular' />
            <Skeleton width={unit(35)} height={unit(6)} />
            <Skeleton width={unit(35)} height={unit(6)} />
            <Skeleton width={unit(35)} height={unit(6)} />
          </Stack>
          <FontAwesomeIcon fontSize={remUnit(3.5)} icon={ICONS.farPencil} />
        </Box>

        <Divider />

        <Box
          bgcolor={COLORS.vaalea['60%']}
          display='flex'
          justifyContent='space-between'
          paddingTop={unit(3.5)}
          paddingBottom={unit(4.5)}
          paddingX={unit(7)}
        >
          <Stack gap={unit(0.5)}>
            <Skeleton width={unit(65)} height={unit(5.5)} variant='rectangular' />
            <Skeleton width={unit(35)} height={unit(4.5)} />
          </Stack>
          <FontAwesomeIcon fontSize={remUnit(3.5)} icon={ICONS.farPencil} />
        </Box>

        <Divider />

        <Box
          bgcolor={COLORS.vaalea['60%']}
          display='flex'
          justifyContent='space-between'
          alignItems='center'
          paddingTop={unit(3.5)}
          paddingBottom={unit(4.5)}
          paddingX={unit(7)}
        >
          <Stack gap={unit(0.5)}>
            <Skeleton width={unit(65)} height={unit(5.5)} variant='rectangular' />
          </Stack>
          <FontAwesomeIcon fontSize={remUnit(3.5)} icon={ICONS.farChevronRight} />
        </Box>

        <DividerWithLabel>{t('account.useful-links')}</DividerWithLabel>

        {Array.from({ length: 5 }).map((_, index) => (
          <Fragment key={`links-${index}`}>
            <Box
              bgcolor={COLORS.vaalea['60%']}
              display='flex'
              justifyContent='space-between'
              paddingTop={unit(3.5)}
              paddingBottom={unit(4.5)}
              paddingX={unit(7)}
            >
              <Stack gap={unit(0.5)}>
                <Skeleton width={unit(65)} height={unit(5.5)} variant='rectangular' />
              </Stack>
              <FontAwesomeIcon fontSize={remUnit(3.5)} icon={ICONS.farArrowUpRightFromSquare} />
            </Box>
            {index < 5 && <Divider />}
          </Fragment>
        ))}
      </Stack>
    </LayoutNavigationBack>
  )
}
